import { FC } from 'react';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import { isEmpty } from 'radash';
import theme from '@shared/assets/palette.json';
import { Container, DateAndView, Description, ListTag, ThumbImage, TipsAction, Title } from './Card.style';
const Tag = dynamic(() => import('@components/tag/Tag'));
interface Props {
  imageUrl: string;
  date: string;
  title: string;
  description: string;
  tag: string[];
  slug: string;
  viewer: number;
  onClickTracker: () => void;
}
const TipsAndTricksCard: FC<Props> = ({
  imageUrl,
  date,
  title,
  description,
  tag,
  slug,
  viewer,
  onClickTracker
}: Props) => {
  return <Link href={`/tips-tricks/${slug}`} onClick={onClickTracker}>
            <Container>
                <ThumbImage src={imageUrl || '/images/default/tips-and-tricks.jpg'} alt={title} onError={({
        currentTarget
      }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = '/images/default/tips-and-tricks.jpg';
      }} placeholder="blur" blurDataURL="/images/default/tips-and-tricks.jpg" width={335} height={188} />
                <DateAndView>
                    <span>{date}</span>
                    {/* //TODO: ปิดไว้ก่อน รอเปิดตอน integrate login แล้ว */}
                    {/* {viewer > 0 && (
                     <div className="viewer">
                        <img src="/icons/eye-grey.svg" alt="eye icon" />
                        <span>
                            {numeral(viewer).format('0.0a').toLowerCase()}
                        </span>
                     </div>
                     )} */}
                </DateAndView>
                <Title>{title}</Title>
                <Description>{description}</Description>
                <TipsAction>
                    <ListTag>
                        {!isEmpty(tag) && tag?.map((text, index) => <Tag key={index} text={text} bgColor="transparent" borderColor={theme.grey[20]} />)}
                    </ListTag>
                </TipsAction>
            </Container>
        </Link>;
};
export default TipsAndTricksCard;